import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { saveAs } from "@/hooks/downUrl";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { defineComponent, ref } from "vue";
import { changeInfoTotal } from "@/hooks/changeInfoTotal";
export default defineComponent({
  props: {
    callback: {
      type: Boolean,
      default: false
    }
  },
  emits: ["pickTiem", "dosom", "dow"],
  setup: function setup(props, ctx) {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var tableData = ref([]); // 获取列表还是直接渲染列表

    function showList(obj) {
      if (obj.type == "ids") {
        getUploadInfo(obj.value);
      } else if (obj.type == "detail") {
        tableData.value = obj.value;
      }
    }

    function getUploadInfo(_x) {
      return _getUploadInfo.apply(this, arguments);
    } //下载


    function _getUploadInfo() {
      _getUploadInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ids) {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(ids != "")) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getAttachment"]({
                  ids: ids
                });

              case 3:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                tableData.value = data;
                ctx.emit("dosom", tableData);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getUploadInfo.apply(this, arguments);
    }

    function downUrl(id) {
      if (props.callback) {
        ctx.emit("pickTiem", id, function () {
          if (id) {
            saveAs(id);
            ctx.emit("dow", 1);

            if (sessionStorage.getItem("user")) {
              changeInfoTotal(id, "\u4E0B\u8F7D:".concat(tableData.value[0].realName), 6);
            }
          } else {
            ElMessage.error("资源已失效");
          }
        });
      } else {
        if (id) {
          saveAs(id);
          ctx.emit("dow", 1);

          if (sessionStorage.getItem("user")) {
            changeInfoTotal(id, "\u4E0B\u8F7D:".concat(tableData.value[0].realName), 6);
          }
        } else {
          ElMessage.error("资源已失效");
        }
      }
    }

    return {
      tableData: tableData,
      showList: showList,
      downUrl: downUrl
    };
  }
});